import React, { FC, PropsWithChildren } from "react";
import { createContext } from "shared/utils/context";
import { useUsersData } from "../../../hooks/useUsersData";
import { UsersPageType } from "./types";

const [Provider, useUsersPage] = createContext<UsersPageType>({
  name: "UsersPageContext",
  hookName: "useUsersPage",
  providerName: "UsersPageProvider",
});

const UsersPageProvider: FC<PropsWithChildren> = ({ children }) => {
  const { searchData, isLoading, tableData } = useUsersData();

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value = {
    loading: isLoading,
    searchData,
    tableData,
  };

  return <Provider value={value}>{children}</Provider>;
};

export { UsersPageProvider, useUsersPage };
